/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import FileUploadModel from '../fileupload/FileUploadModel';
import fileUploadConfig from '../fileupload/fileUploadConfig';
import tmplFileDownloadStatic from '../fileupload/FileDownloadStaticTmpl.hbs';

export default async function downloadDocument(data) {
  const { attachmentId, fileName, isStatic, downloadType } = data;
  const { timeout, searchPath } = fileUploadConfig;
  const downloadXml = isStatic ? tmplFileDownloadStatic : fileUploadConfig.downloadXml;

  const fileUploadModel = new FileUploadModel({
    tmplSoapMessage: downloadXml,
    timeout,
    searchPath,
    fileName,
    attachmentId,
    downloadType
  });

  if (!isStatic) {
    // const documentExists = await GetDoesDocumentExist(fileId);
    // if (!documentExists) {
    //   showErrorMessage({
    //     errorCode: 'file:download:not-found',
    //     errorTitle: 'File Not Found',
    //     errorMessage:
    //       'The file which you attempted to download no longer exists. You will not be able to download the requested document.',
    //   });
    //   return;
    // }
  }
  fileUploadModel.download($('#downloadFormUtil'));
}
